import { render, staticRenderFns } from "./t-language-switcher.vue?vue&type=template&id=acb0cd90&scoped=true&"
import script from "./t-language-switcher.vue?vue&type=script&lang=js&"
export * from "./t-language-switcher.vue?vue&type=script&lang=js&"
import style0 from "./t-language-switcher.vue?vue&type=style&index=0&id=acb0cd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0cd90",
  null
  
)

export default component.exports